import { render, staticRenderFns } from "./review-list-search.vue?vue&type=template&id=5f7d255a&"
import script from "./review-list-search.vue?vue&type=script&lang=js&"
export * from "./review-list-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports